module.exports = __webpack_public_path__ + "img/didi.9f9f0170.png";